<template>
	<div class="quick-brief-list">
		<p v-if="title" class="quick-brief-list__title">{{ title }}</p>
		<div class="quick-brief-list__items">
			<button v-for="item in normalizedItems" :key="item.id" type="button" class="quick-brief-list__item" @click="$emit('select', item)">
				<span class="quick-brief-list__item-title">{{ item.label }}</span>
				<span v-if="item.description" class="quick-brief-list__item-description">{{ item.description }}</span>
			</button>
		</div>
	</div>
</template>

<script>
import { computed } from "vue";

const defaultItems = [
	{
		id: "instagram-giveaway",
		label: "Instagram giveaway",
		description: "A quick social-led collab concept.",
	},
	{
		id: "bundle-feature",
		label: "Product bundle feature",
		description: "A simple partner bundle or swap idea.",
	},
	{
		id: "email-feature",
		label: "Email feature",
		description: "A newsletter or email placement collab.",
	},
	{
		id: "seasonal-campaign",
		label: "Seasonal campaign",
		description: "A timely campaign tied to a key date.",
	},
];

export default {
	name: "QuickBriefCollabList",
	emits: ["select"],
	props: {
		title: {
			type: String,
			default: "Choose a collab type to start a request brief",
		},
		items: {
			type: Array,
			default: () => defaultItems,
		},
	},
	setup(props) {
		const normalizedItems = computed(() => {
			return (props.items || []).map((item, index) => ({
				...item,
				id: item.id || `quick-brief-item-${index}`,
				label: item.label || item.title || `Option ${index + 1}`,
				description: item.description || "",
			}));
		});

		return {
			normalizedItems,
		};
	},
};
</script>

<style lang="less" scoped>
@import "./../../assets/css/less/_settings.less";
@import "./../../assets/css/less/_helper.less";

.quick-brief-list {
	padding: 16px;
	border: 1px solid @guidedRoseBorder;
	border-radius: @radiusLg;
	background: fade(@formDefaultColour, 6%);
}

.quick-brief-list__title {
	margin: 0 0 12px;
	font-size: 14px;
	font-weight: @bold;
	color: @guidedRose;
}

.quick-brief-list__items {
	display: flex;
	flex-direction: column;
	gap: 10px;
}

.quick-brief-list__item {
	width: 100%;
	text-align: left;
	padding: 12px 14px;
	border: 1px solid fade(@formDefaultColour, 30%);
	border-radius: @radiusLg;
	background: #fff;
	cursor: pointer;
	transition: 0.2s ease;
}

.quick-brief-list__item:hover,
.quick-brief-list__item:focus {
	border-color: @formDefaultColour;
	.elevation.cardHover();
	outline: none;
}

.quick-brief-list__item-title {
	display: block;
	font-size: 14px;
	font-weight: @bold;
	color: @darkContrast;
}

.quick-brief-list__item-description {
	display: block;
	margin-top: 4px;
	font-size: 12px;
	line-height: 1.4;
	color: @textSubtle;
}
</style>
